export default "__VITE_ASSET__CHecnAWX__"